import { MethodologyPoints } from '../constants';
import {
  calculateAnnualFeesScore,
  calculateCardDeposit,
  calculateScore,
} from './shared';
import { Question } from './types';
import { CalculateMethodology } from '../utils';
import { ExperimentsReducer } from 'src/redux/reducers/experiments';
import { isNewBuildCreditFlowExperimentActive } from 'src/lib/experiments';

const { THIRTEEN_POINTS } = MethodologyPoints;

export const STUDENT_QUESTIONS: Question[] = [
  {
    availablePoints: THIRTEEN_POINTS,
    calculate: calculateAnnualFeesScore,
  },
  {
    availablePoints: THIRTEEN_POINTS,
    calculate: calculateCardDeposit,
  },
];

export const BUILD_CREDIT_QUESTIONS = (
  experiments?: ExperimentsReducer
): Question[] => {
  return [
    ...(experiments && isNewBuildCreditFlowExperimentActive(experiments)
      ? []
      : [
          {
            availablePoints: THIRTEEN_POINTS,
            calculate: calculateAnnualFeesScore,
          },
        ]),
    {
      availablePoints: THIRTEEN_POINTS,
      calculate: calculateCardDeposit,
    },
  ];
};

export const getBuildCreditMethodology: CalculateMethodology = (
  answers,
  offer,
  experiments
) => {
  return calculateScore(
    answers,
    offer,
    BUILD_CREDIT_QUESTIONS(experiments),
    experiments
  );
};

export const getStudentMethodology: CalculateMethodology = (answers, offer) => {
  return calculateScore(answers, offer, STUDENT_QUESTIONS);
};
